module.exports = __webpack_public_path__ + "static/img/1039_big.482109f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1039_big.png
// module id = z47Y
// module chunks = 1